import React from 'react';
import { makeStyles } from '@material-ui/core';
import { NavLink } from "react-router-dom";
import ProductionLineContent from '../../Dashboard/ProductionLineContent';

export default function DashboardOverviewPage(props) {

    const classes = useStyles();

    let backgroundWidth = String((props.workstation.workstations.length * 343) + 2) + "px"
    return (
        <div className={classes.background} style={{ width: backgroundWidth }}>
            <div className={classes.spacer80}>Production lines overview</div>
            <div className={classes.workstations}></div>
            {props.workstation.workstations.map((workstation) => (
                <NavLink key={workstation.id} className={classes.navButton} to={`/dashboard/${workstation.id}`}>
                    <ProductionLineContent workstation={workstation} border={props.workstation.selectedWorkstation === workstation.id? "1px solid #4654FB": "none"}></ProductionLineContent>
                </NavLink>
            ))}
        </div>
    )
}

const useStyles = makeStyles({
    spacer80: {
        height: '50px',
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: '#000000',
        paddingLeft:"5px"
    },   
    navButton: {
        textDecoration: 'none'
    },

    background: {
        overflow: "auto",
        padding: "20px",
        marginTop:"40px"
    },
    workstations: {
        width: 'fit-content'
    }
});